<template lang="html">
  <div class="choose-city">
    <div
      class="city-location"
      @click="clickLocate(locateCity)"
      v-show="hideLocate"
    >
      <p v-if="hasLocated" class="cityName">
        {{ locateCity.NAME }}<span>当前定位城市</span>
      </p>
      <p v-else class="fail">定位失败</p>
    </div>
    <div class="city-hot" v-show="hotCity && hotCity.length > 0">
      <p>热门城市</p>
      <ul>
        <li v-for="city in hotCity" :key="city.ID" @click="clickCity(city)">
          {{ city.NAME }}
        </li>
      </ul>
    </div>
    <div class="city-all">
      <dl v-for="(item, index) in allCity" :key="index">
        <dt :data-label="getKey(item)">{{ getKey(item) }}</dt>
        <dd>
          <ul>
            <li
              v-for="city in getValue(item)"
              :key="city.ID"
              @click="clickCity(city)"
            >
              {{ city.NAME }}
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <letter :letterList="letters" :wrapper="wrapper"></letter>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import storage from '@/plugins/localStorage'
import letter from './city-letter'

export default {
  props: {
    wrapper: {
      type: String,
      default: ''
    },
    hasLocated: {
      type: Boolean,
      default: false
    },
    hideLocate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allCity: []
    }
  },
  created() {
    this.getCity()
    this.getHotCity()
  },
  computed: {
    ...mapState(['locateCity', 'hotCity']),
    letters() {
      return this.allCity.map(ele => this.getKey(ele))
    }
  },
  methods: {
    async getCity() {
      try {
        // ${this.hostname('subscriber')}/subscriber-web/schedual/getSchedualAreas.do
        const allCity_res = await fetch(
          `${this.hostname(
            'activity'
          )}/activity/storeO2O/queryStoreListByType.do`
        )
        const allCityJson = await allCity_res.json()
        if (allCityJson) {
          let d = allCityJson.data
          d = d.map(ele => ({
            ID: ele.city_code,
            NAME: ele.city,
            PINYIN: ele.spell
          }))
          // 按拼音首字母A-Z排序
          d.sort((a, b) => {
            const a_pinyin = this.firstWordUpper(a.PINYIN)
            const b_pinyin = this.firstWordUpper(b.PINYIN)
            if (a_pinyin > b_pinyin) {
              return 1
            } else if (a_pinyin === b_pinyin) {
              return 0
            } else {
              return -1
            }
          })

          const obj = {}
          const arr = []

          d.forEach(v => {
            const firstLetter = v.PINYIN.charAt(0).toUpperCase()
            if (obj[firstLetter]) {
              obj[firstLetter].push(v)
            } else {
              obj[firstLetter] = []
              obj[firstLetter].push(v)
            }
          })

          Object.keys(obj)
            .sort()
            .forEach(v => {
              const temp = {}
              temp[v] = obj[v]
              arr.push(temp)
            })
          this.allCity = arr
        }
      } catch (e) {
        console.log(e)
      }
    },
    getHotCity() {
      this.$store.dispatch('getMainConfig')
    },
    clickCity(city, type) {
      this.$emit('selectCity', city)
      storage.setItem('vlocateCity', city)
      if (type === 'history') {
        this.$$tracker('130201', '20000', 2110, city.NAME)
      } else {
        this.$$tracker('130201', '20000', 21108, city.NAME)
      }
      // location.replace(`/v/home?citycode=${city.ID}&cityname=${city.NAME}&source=citylist`)
    },
    getKey(obj) {
      return Object.keys(obj)[0]
    },
    getValue(obj) {
      return obj[Object.keys(obj)[0]]
    },
    firstWordUpper(pinyin) {
      return pinyin.match(/^[A-Z]?[a-z]*/)[0].toUpperCase()
    },
    hostname(prefix = '') {
      const hn = location.hostname
      return hn.indexOf('haiziwang.com') > -1
        ? `//${prefix}.haiziwang.com`
        : `//${prefix}.cekid.com`
    },
    clickLocate(city) {
      // this.$emit('selectCity', city)
      // if (city.isAddress || city.isLocated) {
      // }
      if (city.ID && city.ID !== '') {
        this.clickCity(city)
      }
    }
  },
  components: {
    letter
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.choose-city {
  background: #f4f4f4;
  font-size: rem(28px);
  min-height: 100%;

  .city-location {
    display: flex;
    align-items: center;
    padding: 0 rem(20px);
    height: rem(80px);
    background: #fff;

    > p.cityName {
      color: #ff397e;
      span {
        margin-left: rem(15px);
        color: #999;
        font-size: rem(26px);
      }
    }
    > p.fail {
      flex: 1;
    }
  }
  .city-hot,
  .city-history {
    background: #f4f4f4;
    padding: 0 rem(20px);

    p {
      height: rem(80px);
      line-height: rem(80px);
      color: #999;
    }
    ul {
      margin-bottom: rem(-20px);
      overflow: hidden;
    }
    li {
      float: left;
      width: rem(200px);
      // height: rem(60px);
      margin: 0 rem(20px) rem(30px) 0;
      background: #fff;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: rem(60px);

      @include border(all, #999);
    }
  }
  .city-all {
    dt {
      height: rem(80px);
      padding-left: rem(20px);
      font-size: rem(32px);
      line-height: rem(80px);
      background: #f4f4f4;
      color: #999;
    }
    ul {
      padding-left: rem(20px);
      background: #fff;
    }
    li {
      height: rem(80px);
      line-height: rem(80px);
      @include border(bottom, #e8e8e8);

      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
